<template>
  <div class="drawer">
    <div class="drawer-container">
      <div class="drawer-content with-footer">
        <el-form
          ref="productForm"
          :model="product"
          label-width="80px"
          size="small"
          class="box"
        >
          <fieldset class="mgb15">
            <legend>
              {{ $t("text.baseInfo") }}
            </legend>
            <el-row>
              <el-col :span="8">
                <el-form-item
                  :label="$t('product.productNo')"
                  :prop="'productNo'"
                  :rules="[
                    {
                      required: true,
                      validator: validateProductNo,
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input size="small" v-model.trim="product.productNo" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('product.category')"
                  :prop="'categoryId'"
                >
                  <el-select
                    size="small"
                    v-model="product.categoryId"
                    clearable
                    filterable
                    @change="selsectCategory"
                  >
                    <el-option
                      v-for="category in categories"
                      :key="category.id"
                      :label="category.name"
                      :value="category.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('product.unit')"
                  :prop="'unit'"
                  :rules="[
                    {
                      required: true,
                      message: $t('rules.required', [$t('product.unit')]),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-select
                    size="small"
                    v-model="product.unit"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="unit in units"
                      :key="unit"
                      :label="unit"
                      :value="unit"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('product.brand')" :prop="'brand'">
                  <el-select
                    size="small"
                    v-model="product.brand"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="brand in brands"
                      :key="brand.id"
                      :label="brand.name"
                      :value="brand.name"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('product.purchaseUrl')"
                  :prop="'purchaseUrl'"
                >
                  <el-input size="small" v-model.trim="product.purchaseUrl" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('product.mainMaterial')"
                  :prop="'mainMaterial'"
                >
                  <el-input size="small" v-model.trim="product.mainMaterial" />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <template
                v-if="
                  Permit.extendModels().includes('mes') &&
                  Permit.currentTenant().config.mesSchedule == true
                "
              >
                <el-col :span="8">
                  <el-form-item
                    :label="$t('product.mesCycle')"
                    :prop="'mesCycle'"
                  >
                    <el-input size="small" v-model.trim="product.mesCycle" />
                  </el-form-item>
                </el-col>
                <el-col :span="8" v-if="calcTotalPeriod > 0">
                  <span class="font10 mgl5 grey" style="line-height: 42px"
                    >已配工序生产周期和:{{ calcTotalPeriod }}</span
                  >
                </el-col>
              </template>
            </el-row>
          </fieldset>
          <fieldset class="mgb15" v-if="product && product.productHsInfo">
            <legend>{{ $t("product.productHsInfo") }}</legend>
            <el-row>
              <el-col :span="8">
                <el-form-item
                  :label="$t('category.hsCode')"
                  :prop="'productHsInfo.hsCode'"
                >
                  <el-input
                    size="small"
                    v-model.trim="product.productHsInfo.hsCode"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('category.goodsName')"
                  :prop="'productHsInfo.goodsName'"
                >
                  <el-input
                    size="small"
                    v-model.trim="product.productHsInfo.goodsName"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('category.goodsNameEn')"
                  :prop="'productHsInfo.goodsNameEn'"
                >
                  <el-input
                    size="small"
                    v-model.trim="product.productHsInfo.goodsNameEn"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item
                  :label="$t('category.weight')"
                  :prop="'productHsInfo.weight'"
                >
                  <el-input
                    size="small"
                    v-model.trim="product.productHsInfo.weight"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('category.firstUnit')"
                  :prop="'productHsInfo.firstUnit'"
                  label-width="100px"
                >
                  <el-input
                    size="small"
                    v-model.trim="product.productHsInfo.firstUnit"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('category.secondUnit')"
                  :prop="'productHsInfo.secondUnit'"
                  label-width="100px"
                >
                  <el-input
                    size="small"
                    v-model.trim="product.productHsInfo.secondUnit"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('category.declareInfo')"
                  :prop="'productHsInfo.declareInfo'"
                >
                  <el-input
                    size="small"
                    v-model.trim="product.productHsInfo.declareInfo"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('category.insured')"
                  :prop="'productHsInfo.insured'"
                >
                  <el-input
                    size="small"
                    v-model.trim="product.productHsInfo.insured"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>
          <fieldset class="mgb15">
            <legend>{{ $t("product.productNoAlias") }}</legend>
            <el-row>
              <el-col
                :span="8"
                v-for="(productNoItem, pNoIndex) of product.productNos"
                :key="pNoIndex"
              >
                <el-form-item
                  :label="$t('product.alias') + (pNoIndex + 1)"
                  label-width="100px"
                >
                  <span slot="label">
                    <span>{{ $t("product.alias") + (pNoIndex + 1) }}</span>
                    <span v-if="productNoItem.error == true" class="red"
                      >(重复)</span
                    >
                  </span>
                  <el-input
                    size="small"
                    v-model.trim="productNoItem.productNo"
                    style="width: 100%"
                    @blur="blurProductNo(pNoIndex)"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <div class="center">
              <el-button
                type="info"
                @click="addMoreProductNo"
                size="mini"
                plain
                round
                >+ {{ $t("text.more") }}</el-button
              >
            </div>
          </fieldset>
          <el-row :gutter="10">
            <el-col :span="15">
              <fieldset class="mgb15">
                <legend>{{ $t("product.label") }}</legend>
                <el-row>
                  <span
                    v-for="(labelGroup, labelGroupIndex) of labelGroups"
                    :key="labelGroupIndex"
                  >
                    <el-col :span="12" v-if="labelGroup.name != '--'">
                      <el-form-item :label="labelGroup.name" :prop="'radio'">
                        <el-select
                          size="small"
                          v-model="labelGroup.radio"
                          clearable
                          filterable
                        >
                          <el-option
                            v-for="label in labelGroup.labels"
                            :key="label.id"
                            :label="label.name"
                            :value="label.id"
                          />
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24" v-if="labelGroup.name == '--'">
                      <el-checkbox-group
                        size="small"
                        v-model="labelGroup.radio"
                      >
                        <el-checkbox
                          v-for="label in labelGroup.labels"
                          :key="label.id"
                          :label="label.id"
                          style="width: 120px"
                        >
                          <raw-html-limit-number
                            :content="label.name"
                            :number="8"
                          />
                        </el-checkbox>
                      </el-checkbox-group>
                    </el-col>
                  </span>
                </el-row>
              </fieldset>
              <fieldset class="mgb15">
                <legend>
                  {{ $t("product.color") }}
                  <i class="el-icon-circle-plus green mgl5" @click="addColor" />
                  <el-input
                    v-if="colorsAll.length != 0"
                    class="mgl10"
                    size="mini"
                    style="width: 120px"
                    v-model.trim="searchColor"
                    :placeholder="'颜色 搜索'"
                    @input="searchColorChange"
                  />
                </legend>
                <div v-if="colors.length != 0">
                  <el-checkbox
                    class="mgb10"
                    v-model="checkAllColors"
                    :indeterminate="isIndeterminateColors"
                    @change="handleCheckAllColorsChange"
                    >{{ $t("action.checkAll") }}</el-checkbox
                  >
                  <el-checkbox-group
                    size="small"
                    v-model="checkedColors"
                    @change="handleCheckedColorsChange"
                  >
                    <el-checkbox
                      v-for="color in colors"
                      :key="color.name"
                      :label="color.name"
                      style="width: 30%"
                    >
                      <raw-html-limit-number :content="color.name" :number="8"
                    /></el-checkbox>
                  </el-checkbox-group>
                </div>
              </fieldset>
              <fieldset class="mgb15">
                <legend>
                  {{ $t("product.size") }}
                  <i class="el-icon-circle-plus green mgl5" @click="addSize" />
                  <el-input
                    v-if="sizesAll.length != 0"
                    class="mgl10"
                    size="mini"
                    style="width: 120px"
                    v-model.trim="searchSize"
                    :placeholder="'规格 搜索'"
                    @input="searchSizeChange"
                  />
                </legend>
                <div v-if="sizes.length != 0">
                  <el-checkbox
                    v-model="checkAllSizes"
                    :indeterminate="isIndeterminateSizes"
                    class="mgb10"
                    @change="handleCheckAllSizesChange"
                    >{{ $t("action.checkAll") }}</el-checkbox
                  >
                  <el-checkbox-group
                    v-model="checkedSizes"
                    @change="handleCheckedSizesChange"
                  >
                    <el-checkbox
                      v-for="size in sizes"
                      :key="size.name"
                      :label="size.name"
                      style="width: 30%"
                    >
                      <raw-html-limit-number :content="size.name" :number="8" />
                    </el-checkbox>
                  </el-checkbox-group>
                </div>
              </fieldset>
              <fieldset class="mgb15">
                <legend>{{ $t("menu.attributes") }}</legend>
                <el-checkbox
                  v-if="attributes.length != 0"
                  v-model="checkAllAttributes"
                  :indeterminate="isIndeterminateAttributes"
                  class="mgb10"
                  @change="handleCheckAllAttributesChange"
                  >{{ $t("action.checkAll") }}</el-checkbox
                >
                <el-checkbox-group
                  v-model="checkedAttributes"
                  @change="handleCheckedAttributesChange"
                >
                  <el-checkbox
                    v-for="attribute of attributes"
                    :key="attribute"
                    :label="attribute"
                    size="small"
                    style="width: 30%"
                  >
                    <raw-html-limit-number :content="attribute" :number="8" />
                  </el-checkbox>
                </el-checkbox-group>
              </fieldset>
            </el-col>
            <el-col :span="9">
              <fieldset class="mgb15">
                <legend>
                  {{ $t("product.images") }}
                  <svg-icon icon-class="link" @click="linkImage" />
                </legend>
                <dropzone v-model="product.images" multiple />
              </fieldset>
            </el-col>
          </el-row>
          <fieldset
            class="mgb15"
            v-if="
              Permit.canActions('globalCostPrice') &&
              (Permit.extendModels().includes('mms') ||
                Permit.extendModels().includes('mes'))
            "
          >
            <legend>{{ $t("product.cost") }}</legend>
            <el-row>
              <el-col
                v-if="
                  Permit.extendModels().includes('mms') &&
                  Permit.canActions('globalCostPrice')
                "
                :span="8"
              >
                <el-form-item :label="$t('material.baseCost')">
                  {{ mmsCost | currency }}
                </el-form-item>
              </el-col>
              <el-col
                v-if="
                  Permit.extendModels().includes('mes') &&
                  Permit.canActions('globalCostPrice') &&
                  mesCost.length != 0
                "
                :span="16"
              >
                <el-form-item :label="$t('phase.baseCost')">
                  <span
                    v-for="(mesc, index) of mesCost"
                    :key="index"
                    class="mgr10 font10"
                  >
                    {{ mesc.factoryName }}:{{ mesc.cost | currency }}
                  </span>
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>

          <fieldset class="mgb15">
            <legend>{{ $t("product.price") }}</legend>
            <el-row v-if="Permit.canActions('globalSalePrice')" :gutter="5">
              <el-col :span="7">
                <el-form-item
                  :label="$t('product.salesPrice')"
                  :prop="'salesCurrency'"
                  :rules="[
                    {
                      required: true,
                      message: $t('rules.required', [
                        $t('product.salesCurrency'),
                      ]),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input
                    v-model.trim="product.salesPrice"
                    class="input-with-select"
                  >
                    <el-select
                      size="small"
                      v-model="product.salesCurrency"
                      filterable
                      slot="prepend"
                      style="width: 100px"
                    >
                      <el-option
                        v-for="currency in currencies"
                        :key="currency.id"
                        :label="currency.text"
                        :value="currency.code"
                      />
                    </el-select>
                  </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="17">
                <el-form-item v-if="!salesPriceSizesDF" label-width="20px">
                  <small class="blue" @click="showSizesPrice('salesPrice')">{{
                    $t("product.sizePrice")
                  }}</small>
                </el-form-item>
                <el-form-item
                  v-if="salesPriceSizesDF && salesPriceSizes.length == 0"
                  label-width="20px"
                >
                  <small class="orange">{{ $t("prompt.noSelectSize") }}</small>
                </el-form-item>
                <el-row
                  v-if="salesPriceSizesDF && salesPriceSizes.length != 0"
                  :gutter="10"
                >
                  <el-col
                    v-for="item in salesPriceSizes"
                    :key="item.size"
                    :span="6"
                    class="mgb10"
                  >
                    <el-input size="small" v-model.trim="item.price">
                      <template slot="prepend">
                        <div>
                          <raw-html-limit-number
                            :content="item.size"
                            :number="8"
                          />
                        </div>
                      </template>
                    </el-input>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row v-if="Permit.canActions('globalCostPrice')" :gutter="5">
              <el-col :span="7">
                <el-form-item
                  :label="$t('product.costPrice')"
                  :prop="'costPrice'"
                  :rules="[
                    {
                      required: true,
                      message: $t('rules.required', [$t('product.costPrice')]),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input size="small" v-model.trim="product.costPrice" />
                </el-form-item>
              </el-col>
              <el-col :span="17">
                <el-form-item v-if="!costPriceSizesDF" label-width="20px">
                  <small class="blue" @click="showSizesPrice('costPrice')">{{
                    $t("product.sizePrice")
                  }}</small>
                </el-form-item>
                <el-form-item
                  v-if="costPriceSizesDF && costPriceSizes.length == 0"
                  label-width="20px"
                >
                  <small class="orange">{{ $t("prompt.noSelectSize") }}</small>
                </el-form-item>

                <el-row
                  v-if="costPriceSizesDF && costPriceSizes.length != 0"
                  :gutter="10"
                >
                  <el-col
                    v-for="item in costPriceSizes"
                    :key="item.size"
                    :span="6"
                    class="mgb10"
                  >
                    <el-input size="small" v-model.trim="item.price">
                      <template slot="prepend">
                        <div>
                          <raw-html-limit-number
                            :content="item.size"
                            :number="6"
                          />
                        </div>
                      </template>
                    </el-input>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row :gutter="5">
              <el-col :span="7">
                <el-form-item :label="$t('product.wholeSalePrice')">
                  <el-input
                    size="small"
                    v-model.trim="product.wholesalePrice"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="17">
                <el-form-item v-if="!wholesalePriceSizesDF" label-width="20px">
                  <small
                    class="blue"
                    @click="showSizesPrice('wholesalePrice')"
                    >{{ $t("product.sizePrice") }}</small
                  >
                </el-form-item>
                <el-form-item
                  v-if="
                    wholesalePriceSizesDF && wholesalePriceSizes.length == 0
                  "
                  label-width="20px"
                >
                  <small class="orange">{{ $t("prompt.noSelectSize") }}</small>
                </el-form-item>
                <el-row
                  v-if="
                    wholesalePriceSizesDF && wholesalePriceSizes.length != 0
                  "
                  :gutter="10"
                >
                  <el-col
                    v-for="item in wholesalePriceSizes"
                    :key="item.size"
                    :span="6"
                    class="mgb10"
                  >
                    <el-input size="small" v-model.trim="item.price">
                      <template slot="prepend">
                        <div>
                          <raw-html-limit-number
                            :content="item.size"
                            :number="6"
                          />
                        </div>
                      </template>
                    </el-input>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </fieldset>
          <fieldset class="mgb15">
            <legend>{{ $t("product.introduction") }}</legend>
            <el-input
              v-model="product.introduction"
              type="textarea"
              :rows="2"
            />
          </fieldset>
          <fieldset
            class="mgb15"
            v-if="Permit.canActions('productManageCraftwork')"
          >
            <legend>
              <span style="float: left">{{ $t("product.craftwork") }}</span>
              <el-tag
                v-for="(template, templateIndex) of craftworkTemplates"
                :key="templateIndex"
                :effect="template.effect"
                size="mini"
                @click="selectCraftworkTemplate(template, templateIndex)"
                class="cursor-pointer"
              >
                {{ template.name }}
              </el-tag>
            </legend>
            <tinymce-editor
              ref="editor"
              v-model="product.craftwork"
              :height="300"
            />
          </fieldset>
        </el-form>
      </div>
    </div>
    <div class="drawer-footer">
      <el-button
        type="primary"
        size="small"
        plain
        :loading="saveDoing"
        @click="saveSubmit"
        >{{ $t("text.submit") }}</el-button
      >
    </div>
    <el-dialog
      :append-to-body="true"
      :title="$t('action.linkImage')"
      :visible.sync="linkImageDF"
      :close-on-click-modal="false"
      width="50%"
    >
      <el-form ref="linkImageObjForm" :model="linkImageObj">
        <el-form-item
          :prop="'linkImageStr'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('action.linkImage')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="linkImageObj.linkImageStr"
            :placeholder="$t('prompt.linkImageExplain')"
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 10 }"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="linkImageDoing"
          size="small"
          @click="linkImageSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="linkImageDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :append-to-body="true"
      :title="$t('action.productAsyncInv')"
      :visible.sync="asyncInvDF"
      :close-on-click-modal="false"
      width="30%"
    >
      <el-form ref="asyncInvForm" :model="asyncInvObj">
        <el-form-item :prop="'asyncInv'">
          <el-checkbox
            v-model="asyncInvObj.asyncInv"
            @change="changeAsyncInv"
            >{{ $t("action.productAsyncInv") }}</el-checkbox
          >
        </el-form-item>
        <el-form-item :prop="'asyncInv'">
          <span class="red">{{ $t("prompt.productNoAsyncInvExplain") }}</span>
        </el-form-item>
        <el-form-item v-if="asyncInvObj.asyncInv" :prop="'confirmAsyncInv'">
          <el-checkbox v-model="asyncInvObj.confirmAsyncInv">{{
            $t("action.confirmAsyncInv")
          }}</el-checkbox>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="asyncInvDoing"
          size="small"
          @click="asyncInvSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="asyncInvDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :append-to-body="true"
      :title="$t('rules.create', [$t('product.color')])"
      :close-on-click-modal="false"
      :visible.sync="addColorDF"
      width="30%"
    >
      <el-form ref="addColorForm" :model="addColorObj">
        <el-form-item
          :prop="'name'"
          :rules="[
            { required: true, validator: validateColor, trigger: 'blur' },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="addColorObj.name"
            :placeholder="$t('text.name')"
          />
        </el-form-item>
        <el-form-item :prop="'image'">
          <upload-single-picture v-model="addColorObj.image" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addColorSubmitDoing"
          size="small"
          @click="addColorSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addColorDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :append-to-body="true"
      :title="$t('rules.create', [$t('product.size')])"
      :close-on-click-modal="false"
      :visible.sync="addSizeDF"
      width="30%"
    >
      <el-form ref="addSizeForm" :model="addSizeObj">
        <el-form-item
          :prop="'name'"
          :rules="[
            { required: true, validator: validateSize, trigger: 'blur' },
          ]"
        >
          <el-input
            size="small"
            v-model.trim="addSizeObj.name"
            :placeholder="$t('text.name')"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="addSizeObj.explain"
            :placeholder="$t('text.explain')"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addSizeSubmitDoing"
          size="small"
          @click="addSizeSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addSizeDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import TinymceEditor from "@/components/TinymceEditor";
import UploadSinglePicture from "@/components/UploadSinglePicture";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";

import Dropzone from "@/components/Dropzone";
import Product from "@/api/product.js";
import Category from "@/api/category.js";
import Enumeration from "@/api/enumeration.js";
import Size from "@/api/size.js";
import Color from "@/api/color.js";
import Label from "@/api/label.js";
import Brand from "@/api/brand";
import PrintTemplate from "@/api/printTemplate.js";
import Currency from "@/api/currency.js";

export default {
  props: {
    uuid: String,
  },
  mixins: [page],
  components: {
    TinymceEditor,
    UploadSinglePicture,
    Dropzone,
    RawHtmlLimitNumber,
  },
  data() {
    var validateProductNo = (rule, value, callback) => {
      const self = this;
      if (value === null || value === "") {
        callback(
          new Error(this.$t("rules.required", [this.$t("product.productNo")]))
        );
        return;
      }
      Product.findByProductNo({ productNo: value }).then(function (res) {
        if (res.data.code === 200 && res.data.entity.id !== self.product.id) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("product.productNo")]))
          );
        } else {
          callback();
        }
      });
    };
    var validateColor = (rule, value, callback) => {
      const self = this;
      if (value === null) {
        callback(
          new Error(this.$t("rules.required", [this.$t("menu.colors")]))
        );
        return;
      }
      if (self.colorsAll.find((s) => s.name === value) != null) {
        callback(new Error(this.$t("rules.exist", [this.$t("menu.colors")])));
      } else {
        callback();
      }
    };
    var validateSize = (rule, value, callback) => {
      const self = this;
      if (value === null) {
        callback(new Error(this.$t("rules.required", [this.$t("menu.sizes")])));
        return;
      }
      if (self.sizesAll.find((s) => s.name === value) != null) {
        callback(new Error(this.$t("rules.exist", [this.$t("menu.sizes")])));
      } else {
        callback();
      }
    };
    return {
      Util: Util,
      validateProductNo: validateProductNo,
      product: {
        showShop: false,
      },
      mmsCost: null,
      mesCost: [],
      calcTotalPeriod: null,

      originalProductNo: null,
      checkedColors: [],
      checkedSizes: [],
      checkedAttributes: [],
      checkedLabelIds: [],
      saveDoing: false,

      categories: [],
      labels: [],
      labelGroups: [],
      sizes: [],
      sizesAll: [],
      colors: [],
      colorsAll: [],
      units: [],
      attributes: [],
      brands: [],
      craftworkTemplates: [],
      currencies: [],
      // 颜色
      isIndeterminateColors: false,
      checkedColors: [],
      checkAllColors: false,
      searchColor: null,
      // 尺码
      isIndeterminateSizes: false,
      checkedSizes: [],
      checkAllSizes: false,
      searchSize: null,
      // 自定义属性
      isIndeterminateAttributes: false,
      checkedAttributes: [],
      checkAllAttributes: false,
      // 尺码价格
      salesPriceSizesDF: false,
      salesPriceSizes: [],
      costPriceSizesDF: false,
      costPriceSizes: [],
      wholesalePriceSizesDF: false,
      wholesalePriceSizes: [],
      // 图片链接
      linkImageDF: false,
      linkImageObj: {
        linkImageStr: null,
      },
      linkImageDoing: false,
      //
      asyncInvDF: false,
      asyncInvObj: {
        asyncInv: false,
        confirmAsyncInv: false,
      },
      asyncInvDoing: false,
      //
      // 新增颜色
      validateColor: validateColor,
      addColorDF: false,
      addColorObj: { name: null, image: null },
      addColorSubmitDoing: false,
      // 新增尺码
      validateSize: validateSize,
      addSizeDF: false,
      addSizeObj: { name: null, explain: null },
      addSizeSubmitDoing: false,
    };
  },

  computed: {},
  created() {
    const self = this;
    self.loadingStart();
    axios
      .all([
        Product.findByUuid({ uuid: self.uuid }),
        Category.findByTenantId(),
        Label.findByTenantId(),
        Label.findAllSortByGroup(),
        Size.findByTenantId(),
        Color.findByTenantId(),
        Enumeration.findByType("unit"),
        Enumeration.findByType("attribute"),
        Brand.findByTenantId(),
        PrintTemplate.findByType({ type: "craftwork" }),
        Currency.findByTenantId(),
      ])
      .then(
        axios.spread(function (
          product,
          categories,
          labels,
          labelGroups,
          sizes,
          colors,
          units,
          attributes,
          brands,
          craftworkTemplates,
          currencies
        ) {
          if (product.data.code === 200) {
            self.product = product.data.entity;
            self.originalProductNo = self.product.productNo;
            self.checkedColors = JSON.parse(self.product.colorJson);
            self.checkedSizes = JSON.parse(self.product.sizeJson);
            self.checkedAttributes = JSON.parse(
              self.product.customAttributeJson
            );
            self.checkedLabelIds = self.product.productLabels.map(function (
              productLabel
            ) {
              return productLabel.labelId;
            });
            self.sizesPriceCompute();
            if (
              self.Permit.extendModels().includes("mms") &&
              self.Permit.canActions("globalCostPrice")
            ) {
              self.getMmsCost(self.product.id);
            }
            if (
              self.Permit.extendModels().includes("mes") &&
              self.Permit.canActions("globalCostPrice")
            ) {
              self.getMesCost(self.product.id);
            }
            if (
              self.Permit.extendModels().includes("mes") &&
              self.Permit.currentTenant().config.mesSchedule == true
            ) {
              self.getMesCalcTotalPeriod(self.product.id);
            }
          } else {
            self.sysError();
          }
          if (categories.status === 200) {
            self.categories = categories.data;
          } else {
            self.sysError();
          }
          if (labels.status === 200) {
            self.labels = labels.data;
          } else {
            self.sysError();
          }
          if (labelGroups.status === 200) {
            self.labelGroups = labelGroups.data;

            for (let labelGroup of self.labelGroups) {
              if (labelGroup.name != "--") {
                let obj = self.product.productLabels.find(
                  (c) => c.groupName == labelGroup.name
                );
                Vue.set(labelGroup, "radio", obj != null ? obj.labelId : null);
              } else {
                Vue.set(
                  labelGroup,
                  "radio",
                  self.product.productLabels
                    .filter((c) => c.groupName == null)
                    .map((c) => c.labelId)
                );
              }
            }
          } else {
            self.sysError();
          }
          if (sizes.status === 200) {
            self.sizes = sizes.data;
            self.sizesAll = sizes.data;
            self.selsectCategoryInit();
          } else {
            self.sysError();
          }
          if (colors.status === 200) {
            self.colors = colors.data;
            self.colorsAll = colors.data;
          } else {
            self.sysError();
          }
          if (units.data.code === 200) {
            self.units = JSON.parse(units.data.entity.itemsJson);
          } else {
            self.sysError();
          }
          if (attributes.data.code === 200) {
            self.attributes = JSON.parse(attributes.data.entity.itemsJson);
          } else {
            self.sysError();
          }
          if (brands.status === 200) {
            self.brands = brands.data;
          } else {
            self.sysError();
          }
          if (craftworkTemplates.status === 200) {
            self.craftworkTemplates = craftworkTemplates.data;
            if (self.craftworkTemplates.length != 0) {
              for (const c of self.craftworkTemplates) {
                Vue.set(c, "effect", "plain");
              }
            }
          } else {
            self.sysError();
          }
          if (currencies.status === 200) {
            for (const currency of currencies.data) {
              Vue.set(
                currency,
                "text",
                currency.symbol + "(" + currency.code + ")"
              );
            }

            self.currencies = currencies.data;
            // .filter((c) => c.display == true);
          } else {
            self.sysError();
          }
          self.loadingEnd();
        })
      );
  },
  methods: {
    addMoreProductNo() {
      let obj = {
        productNo: null,
        productId: this.product.id,
        error: false,
      };
      this.product.productNos.push(obj);
    },
    blurProductNo(pNoIndex) {
      const self = this;
      if ((this.product.productNos[pNoIndex].productNo ?? "") == "") {
        return;
      }
      self.product.productNos[pNoIndex].error = false;
      if (
        this.product.productNos.filter(
          (pNo) => pNo.productNo == this.product.productNos[pNoIndex].productNo
        ).length > 1 ||
        this.product.productNos[pNoIndex].productNo == this.product.productNo
      ) {
        this.$message({
          message: this.$t("rules.repect", [this.$t("product.alias")]),
          type: "warning",
        });
        this.product.productNos[pNoIndex].productNo = null;
        return;
      }
      Product.findByProductNo({
        productNo: self.product.productNos[pNoIndex].productNo,
      }).then(function (res) {
        if (res.data.code === 200) {
          self.$message({
            message: self.$t("rules.exist", [self.$t("product.alias")]),
            type: "warning",
          });
          self.product.productNos[pNoIndex].productNo = null;
        } else {
          //==
        }
      });
    },
    getMmsCost(id) {
      const self = this;
      Product.calcCostMms(id).then(function (res) {
        if (res.status === 200) {
          self.mmsCost = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getMesCost(id) {
      const self = this;
      Product.calcCostMes(id).then(function (res) {
        if (res.status === 200) {
          self.mesCost = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getMesCalcTotalPeriod(id) {
      const self = this;
      Product.calcTotalPeriod(id).then(function (res) {
        if (res.status === 200) {
          self.calcTotalPeriod = res.data;
        } else {
          self.sysError();
        }
      });
    },
    selectCraftworkTemplate(template, templateIndex) {
      for (const c of this.craftworkTemplates) {
        c.effect = "plain";
      }
      this.craftworkTemplates[templateIndex].effect = "dark";
      this.product.craftwork = template.content;
    },
    // 新增尺码
    addSize() {
      this.addSizeObj.name = null;
      this.addSizeObj.explain = null;
      this.addSizeSubmitDoing = false;
      this.addSizeDF = true;
    },
    addSizeSubmit() {
      const self = this;
      this.$refs.addSizeForm.validate((valid) => {
        if (valid) {
          self.addSizeSubmitDoing = true;
          this.addSizeObj.name = this.addSizeObj.name.trim();
          Size.insertBatch([self.addSizeObj]).then(function (res) {
            self.addSizeSubmitDoing = false;
            self.addSizeDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.addSuccess"),
                type: "success",
              });
              self.getSizes();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    getSizes() {
      const self = this;
      Size.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.sizes = res.data;
          self.sizesAll = res.data;
        } else {
          self.sysError();
        }
      });
    },
    // 新增颜色
    addColor() {
      this.addColorObj.name = null;
      this.addColorObj.image = null;
      this.addColorSubmitDoing = false;
      this.addColorDF = true;
    },
    addColorSubmit() {
      const self = this;
      this.$refs.addColorForm.validate((valid) => {
        if (valid) {
          self.addColorSubmitDoing = true;
          Color.insertBatch([this.addColorObj]).then(function (res) {
            self.addColorSubmitDoing = false;
            self.addColorDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.addSuccess"),
                type: "success",
              });
              self.getColors();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    getColors() {
      const self = this;
      Color.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.colors = res.data;
          self.colorsAll = res.data;
        } else {
          self.sysError();
        }
      });
    },
    saveSubmit() {
      const self = this;
      this.$refs.productForm.validate((valid) => {
        if (valid) {
          const productNosFilter = JSON.parse(
            JSON.stringify(self.product.productNos)
          ).filter((pNo) => (pNo.productNo ?? "") != "");
          self.product.productNos = productNosFilter;
          //
          if (
            self.categories.find((c) => c.id == self.product.categoryId) != null
          ) {
            self.product.categoryName = self.categories.find(
              (c) => c.id == self.product.categoryId
            ).name;
          }
          const checkedColorsFilter = self.checkedColors.filter((c) =>
            self.colorsAll.map((c) => c.name).includes(c)
          );
          const sizeNames = self.sizesAll.map((s) => s.name);
          const checkedSizesFilter = self.checkedSizes.filter((c) =>
            sizeNames.includes(c)
          );
          const checkedAttributesFilter = self.checkedAttributes.filter((c) =>
            self.attributes.includes(c)
          );
          // self.product.labelIds = self.checkedLabelIds;
          self.product.labelIds = [];
          for (const labelGroup of self.labelGroups) {
            if (labelGroup.name != "--") {
              if (labelGroup.radio != null) {
                self.product.labelIds.push(labelGroup.radio);
              }
            } else {
              self.product.labelIds = self.product.labelIds.concat(
                labelGroup.radio
              );
            }
          }
          self.product.colorJson = JSON.stringify(checkedColorsFilter);
          self.product.sizeJson = JSON.stringify(checkedSizesFilter);
          self.product.customAttributeJson = JSON.stringify(
            checkedAttributesFilter
          );
          self.product.productSizePrices = [];
          for (const checkedSize of checkedSizesFilter) {
            const obj = {
              size: checkedSize,
              salesPrice: self.salesPriceSizes.find(
                (s) => s.size === checkedSize
              ).price,
              costPrice: self.costPriceSizes.find((s) => s.size === checkedSize)
                .price,
              wholesalePrice: self.wholesalePriceSizes.find(
                (s) => s.size === checkedSize
              ).price,
            };
            if (self.regexSizePriceDF(obj)) {
              self.$message({
                message: self.$t("rules.regex", [self.$t("product.sizePrice")]),
                type: "warning",
              });
              return;
            }

            if (
              !(
                (obj.salesPrice == null || obj.salesPrice === "") &&
                (obj.costPrice == null || obj.costPrice === "") &&
                (obj.wholesalePrice == null || obj.wholesalePrice === "")
              )
            ) {
              self.product.productSizePrices.push(obj);
            }
          }
          if (
            self.originalProductNo !== self.product.productNo &&
            !self.Permit.isFreeEdition() &&
            self.Permit.extendModels().includes("wms")
          ) {
            self.asyncInvDF = true;
          } else {
            self.editFun();
          }
        } else {
          return false;
        }
      });
    },
    changeAsyncInv() {
      if (!this.asyncInvObj.asyncInv) {
        this.asyncInvObj.confirmAsyncInv = false;
      }
    },
    asyncInvSubmit() {
      const self = this;
      if (
        (self.asyncInvObj.asyncInv && self.asyncInvObj.confirmAsyncInv) ||
        (!self.asyncInvObj.asyncInv && !self.asyncInvObj.confirmAsyncInv)
      ) {
        self.editFun();
      } else {
        self.$message({
          message: self.$t("prompt.plaseConfirmAsyncInv"),
          type: "warning",
        });
      }
    },
    editFun() {
      const self = this;
      if (self.asyncInvObj.asyncInv && self.asyncInvObj.confirmAsyncInv) {
        Vue.set(self.product, "asynvInvProductNo", true);
      } else {
        Vue.set(self.product, "asynvInvProductNo", false);
      }
      self.editDoing = true;
      Product.update(self.product.id, self.product).then(function (res) {
        self.editDoing = false;
        self.asyncInvDF = false;
        if (res.status === 200) {
          self.$eventHub.$emit("productUpdate");
          self.sysResult(res.data, self.$t("prompt.editSuccess"));
          self.$emit("updateInfo", self.product);
        } else {
          self.sysError();
        }
      });
    },

    regexSizePriceDF(obj) {
      const self = this;
      if (
        obj.salesPrice != null &&
        obj.salesPrice != "" &&
        !Util.regexPrice(obj.salesPrice)
      ) {
        return true;
      }
      if (
        obj.costPrice != null &&
        obj.costPrice != "" &&
        !Util.regexPrice(obj.costPrice)
      ) {
        return true;
      }
      if (
        obj.wholesalePrice != null &&
        obj.wholesalePrice != "" &&
        !Util.regexPrice(obj.wholesalePrice)
      ) {
        return true;
      }
      return false;
    },

    showSizesPrice(priceType) {
      if (priceType === "salesPrice") {
        this.salesPriceSizesDF = true;
      }
      if (priceType === "costPrice") {
        this.costPriceSizesDF = true;
      }
      if (priceType === "wholesalePrice") {
        this.wholesalePriceSizesDF = true;
      }
    },
    // 图片链接
    linkImage() {
      this.linkImageDF = true;
      this.linkImageObj.linkImageStr = null;
    },
    linkImageSubmit() {
      const self = this;
      self.$refs.linkImageObjForm.validate((valid) => {
        if (valid) {
          const linkImageArr = this.linkImageObj.linkImageStr.split("\n");
          const linkImageArrFilter = linkImageArr.filter((a) => a != null);
          if (self.product.images == null) {
            self.product.images = linkImageArrFilter.join(";");
          } else {
            self.product.images =
              self.product.images + ";" + linkImageArrFilter.join(";");
          }
          self.linkImageDF = false;
        } else {
          return false;
        }
      });
    },

    // 颜色
    handleCheckAllColorsChange(val) {
      this.checkedColors = val ? this.colors.map((c) => c.name) : [];
    },
    handleCheckedColorsChange(value) {
      const checkedCount = value.length;
      this.checkAllColors = checkedCount === this.colors.length;
      this.isIndeterminateColors =
        checkedCount > 0 && checkedCount < this.colors.length;
    },
    searchColorChange() {
      let newSearchColor = this.searchColor.toUpperCase();
      this.colors = this.colorsAll.filter(
        (c) => c.name.toUpperCase().indexOf(newSearchColor) != -1
      );
    },
    // 尺码
    handleCheckAllSizesChange(val) {
      this.checkedSizes = val ? this.sizes.map((s) => s.name) : [];
      this.sizesPriceCompute();
    },
    handleCheckedSizesChange(value) {
      const checkedCount = value.length;
      this.checkAllSizes =
        checkedCount === this.sizes.map((s) => s.name).length;
      this.isIndeterminateSizes =
        checkedCount > 0 && checkedCount < this.sizes.map((s) => s.name).length;
      this.sizesPriceCompute();
    },
    searchSizeChange() {
      this.sizes = this.sizesAll.filter(
        (c) => c.name.toUpperCase().indexOf(this.searchSize.toUpperCase()) != -1
      );
    },

    sizesPriceCompute() {
      this.salesPriceSizes = [];
      this.costPriceSizes = [];
      this.wholesalePriceSizes = [];
      if (this.checkedSizes.length !== 0) {
        for (const checkedSize of this.checkedSizes) {
          const invExistSize = this.product.productSizePrices.find(
            (psp) => psp.size === checkedSize
          );
          this.salesPriceSizes.push({
            size: checkedSize,
            price: invExistSize == null ? null : invExistSize.salesPrice,
          });
          this.costPriceSizes.push({
            size: checkedSize,
            price: invExistSize == null ? null : invExistSize.costPrice,
          });
          this.wholesalePriceSizes.push({
            size: checkedSize,
            price: invExistSize == null ? null : invExistSize.wholesalePrice,
          });
        }
      } else {
        this.salesPriceSizes = [];
        this.costPriceSizes = [];
        this.wholesalePriceSizes = [];
      }
    },
    // 属性
    handleCheckAllAttributesChange(val) {
      this.checkedAttributes = val ? this.attributes : [];
    },

    handleCheckedAttributesChange(value) {
      const checkedCount = value.length;
      this.checkAllAttributes = checkedCount === this.attributes.length;
      this.isIndeterminateAttributes =
        checkedCount > 0 && checkedCount < this.attributes.length;
    },

    selsectCategoryInit() {
      const self = this;
      if (self.product.categoryId === "" || self.product.categoryId == null) {
        self.product.categoryId = null;
        self.sizes = self.sizesAll;
        return;
      }
      const selsectCategoryObj = self.categories.find(
        (c) => c.id === self.product.categoryId
      );
      if (
        selsectCategoryObj &&
        selsectCategoryObj.sizes != null &&
        selsectCategoryObj.sizes.length !== 0
      ) {
        self.sizes = selsectCategoryObj.sizes;
      } else {
        self.sizes = self.sizesAll;
      }
      if (self.checkedSizes.length !== 0) {
        self.checkedSizes = self.checkedSizes.filter(
          (c) => self.sizes.find((s) => s.name === c) != null
        );
        self.sizesPriceCompute();
      }
    },
    selsectCategory() {
      const self = this;
      if (self.product.categoryId === "" || self.product.categoryId == null) {
        self.product.categoryId = null;
        self.sizes = self.sizesAll;
        return;
      }
      const selsectCategoryObj = self.categories.find(
        (c) => c.id === self.product.categoryId
      );
      if (
        selsectCategoryObj &&
        selsectCategoryObj.sizes != null &&
        selsectCategoryObj.sizes.length !== 0
      ) {
        self.sizes = selsectCategoryObj.sizes;
      } else {
        self.sizes = self.sizesAll;
      }
      if (self.checkedSizes.length !== 0) {
        self.checkedSizes = self.checkedSizes.filter(
          (c) => self.sizes.find((s) => s.name === c) != null
        );
        self.sizesPriceCompute();
      }
      if (selsectCategoryObj != null) {
        self.product.productHsInfo.hsCode = selsectCategoryObj.hsCode;
        self.product.productHsInfo.goodsName = selsectCategoryObj.goodsName;
        self.product.productHsInfo.goodsNameEn = selsectCategoryObj.goodsNameEn;
        self.product.productHsInfo.weight = selsectCategoryObj.weight;
        self.product.productHsInfo.declareInfo = selsectCategoryObj.declareInfo;
        self.product.productHsInfo.firstUnit = selsectCategoryObj.firstUnit;
        self.product.productHsInfo.secondUnit = selsectCategoryObj.secondUnit;
        self.product.productHsInfo.insured = selsectCategoryObj.insured;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>